import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import style from './Nodes.style';
import {
    FMIcon,
    FMCheckbox,
    FMCollapseExpand,
    FMTreeNode,
    FMTreeGroupNodeWithStore,
} from 'atoms';
import { GroupProps } from '../../organisms/FMTree/TypesForNodes';

class FMTreeGroupWithItemsNode extends React.Component<GroupProps> {

    public render() {

        let ItemComponent = this.props.itemComponent;

        return (
            <React.Fragment>
                <FMTreeNode
                    level={this.props.level}
                    selected={this.props.selected}
                    selectNode={this.props.selectNode}
                >
                    {
                        (this.props.childGroups.length > 0 || this.props.childItems.length > 0) &&
                            <FMCollapseExpand
                                checked={this.props.expanded}
                                onClick={this.props.expanded ? this.props.collapseGroup : this.props.expandGroup}
                            />
                    }
                    {
                        (this.props.childGroups.length === 0 && this.props.childItems.length === 0) &&
                            <FMIcon type="empty" />
                    }
                    <FMCheckbox
                        checked={this.props.checked}
                        onClick={this.props.checked ? this.props.uncheckNode : this.props.checkNode}
                    />
                    <FMIcon type="group" color="secondary" />
                    <div className={this.props.classes.nodeName}>
                        {this.props.name}
                    </div>
                </FMTreeNode>
                {
                    this.props.expanded && this.props.childGroups.map(id =>
                        <ConnectedFMTreeGroupNode
                            {...this.props}
                            key={id}
                            id={id}
                            level={this.props.level + 1}
                        />
                    )
                }
                {
                    this.props.expanded && this.props.childItems.map(id =>
                        <ItemComponent
                            {...this.props}
                            key={id}
                            id={id}
                            level={this.props.level + 1}
                        />
                    )
                }
            </React.Fragment>
        );
    }

}

const ConnectedFMTreeGroupNode = withStyles(style)(FMTreeGroupNodeWithStore(FMTreeGroupWithItemsNode));

export default ConnectedFMTreeGroupNode;
